import React, { useState, useEffect } from "react";
import { message, Modal, Row, Col, Progress } from "antd";
import { CustomButton, CustomTitle } from "../../components";
import Dragger from "antd/es/upload/Dragger";
import attachImage from "../../assets/images/attachImage.svg";
import bulkshipment from "../../assets/images/BulkShipment.svg";
import DataMappingModal from "../Shipments/BulkShipment/DataMappingModal";
import { uploadBulkShipment } from "../../api's/shipment";
import { useSpin } from "../../components/SpinContext";
import { useToken } from "../../common/helper";
import { useNavigate } from "react-router-dom";

const BulkUploadModal = ({ setModalOpen, modalOpen }) => {
  const [file, setFile] = useState(null);
  const [showMappingModal, setShowMappingModal] = useState(false);
  const { showSpin, hideSpin } = useSpin();
  const [fileKey, setFileKey] = useState(null);
  const [fieldMappings, setFieldMappings] = useState([]);
  const { token, removeToken } = useToken();
  const navigate = useNavigate();

  const handleCancel = () => {
    setModalOpen(false);
    setFile(null);
  };
  const unauthorize = (status) => {
    if (status === 401) {
      removeToken();
      navigate("/login");
    }
  };

  useEffect(() => {
    if (modalOpen) {
      setFile(null);
    }
  }, [modalOpen]);

  const uploadFile = (formData) => {
    uploadBulkShipment(token, formData)
      .then((res) => {
        const data = res?.data?.data || null;

        if (data?.is_success) {
          setFieldMappings(data?.data?.headers_mapping);
          setFileKey(data?.data?.key);
          setShowMappingModal(true);
          setModalOpen(false);
          message.success(data?.message || "Upload successful.");
        } else {
          message.error(
            data?.message?.text || "Upload failed. Please try again."
          );
        }
      })
      .catch((error) => {
        unauthorize(error);
        message.error("Upload failed. Please try again.");
      })
      .finally(() => {
        hideSpin();
      });
  };

  const animateProgress = (newFile) => {
    const formData = new FormData();
    formData.append("files", newFile.raw);
    uploadFile(formData);
    let progress = 0;
    const interval = setInterval(() => {
      progress += 2;
      if (progress >= 100) {
        progress = 100;
        clearInterval(interval);
      }

      setFile((prev) => ({ ...prev, progress }));
    }, 60);
  };

  const handleFileAdd = (fileObj) => {
    const acceptedExtensions = [".csv", ".xls", ".xlsx"];
    const isValidType = acceptedExtensions.some((ext) =>
      fileObj?.name?.toLowerCase()?.endsWith(ext)
    );

    const sizeInMB = fileObj.size / (1024 * 1024);
    const isTooSmall = sizeInMB < 0;
    const isTooLarge = sizeInMB > 20;

    if (!isValidType) {
      message.error(`Unsupported file type: ${fileObj.name}`);
      return;
    }

    if (isTooSmall) {
      message.error(`${fileObj.name} is smaller than 1MB.`);
      return;
    }

    if (isTooLarge) {
      message.error(`${fileObj.name} exceeds 20MB.`);
      return;
    }

    const uid = `${fileObj.name}-${Date.now()}`;
    const newFile = { uid, progress: 0, raw: fileObj };
    setFile(newFile);
    animateProgress(newFile);
  };

  return (
    <>
      <Modal
        title=""
        centered
        open={modalOpen}
        onCancel={handleCancel}
        width={590}
        footer={null}
        styles={{ content: { borderRadius: "18px", overflow: "hidden" } }}
      >
        <CustomTitle
          text="Bulk upload"
          fontSize="20px"
          lineHeight="28px"
          fontWeight="700"
          marginBottom="0px"
        />

        <main style={{ marginTop: "20px" }}>
          <Dragger
            multiple={false}
            showUploadList={false}
            accept=".csv,.xls,.xlsx"
            beforeUpload={(file) => {
              handleFileAdd(file);
              return false;
            }}
            style={{
              backgroundColor: "#fff",
              padding: "0px 100px 30px 100px",
              border: "2px dashed #E2E2E2",
              borderRadius: "12px",
              textAlign: "center",
              cursor: "pointer",
            }}
          >
            <img
              src={bulkshipment}
              alt="upload illustration"
              style={{ marginBottom: "20px", width: "304px", height: "226px" }}
            />
            <CustomTitle
              text="Add shipment data"
              fontSize="20px"
              lineHeight="28px"
              fontWeight="700"
              marginBottom="8px"
            />
            <p
              style={{
                color: "#000000",
                fontSize: "14px",
                fontWeight: "400",
                marginBottom: "24px",
              }}
            >
              Drop your spreadsheet here to upload
              <br />
              <br />
              For best results, data should include Tracking ID, Provider name
              and Product name
            </p>
            <CustomButton
              iconPosition="left"
              image={attachImage}
              paddingImage={5}
              text="Browse files"
              bgColor="#F3F3F3"
              color="#000"
              height="48px"
              width="143px"
              fontSize="14px"
              fontWeight="600"
              boxShadow="none"
              borderRadius="20px"
            />
          </Dragger>

          {file && (
            <Row
              style={{
                width: "100%",
                marginTop: "16px",
                padding: "16px 24px",
                borderRadius: "12px",
                border: "2px solid #E2E2E2",
              }}
            >
              <Col span={24}>
                <p
                  style={{
                    color: "#5E5E5E",
                    fontSize: "12px",
                    fontWeight: "600",
                    marginBottom: 0,
                    overflowWrap: "anywhere",
                  }}
                >
                  {file.raw.name}
                </p>

                <Progress
                  percent={file.progress}
                  showInfo={false}
                  strokeColor="#266EF1"
                  trailColor="#D9D9D9"
                />
              </Col>
            </Row>
          )}
        </main>
      </Modal>

      <DataMappingModal
      setFieldMappings={setFieldMappings}
        fieldMappings={fieldMappings}
        setModalOpen={setModalOpen}
        fileKey={fileKey}
        unauthorize={unauthorize}
        showMappingModal={showMappingModal}
        setShowMappingModal={setShowMappingModal}
      />
    </>
  );
};

export default BulkUploadModal;
